<p
  class="font-red font-size-sm mb-5"
  *ngIf="submitted && form.controls.dates.hasError('invalidSelectedDays')"
>
  {{ 'validation.invalidSelectedDays' | translate }}
</p>

<form
  [formGroup]="form"
  [ngClass]="{ 'was-validated': submitted }"
>
  <div [ngStyle]="{ 'padding-bottom': requirementsOpen ? '26rem' : 0 }">
    <div
      formGroupName="dates"
      class="row align-items-center mb-3"
    >
      <div class="col-4">
        <label class="required fw-medium">{{ 'inquiry.period' | translate }}</label>
      </div>
      <div class="col d-flex align-items-center">
        <base-range-datepicker
          [isRequired]="true"
          formControlName="range"
          placement="bottom"
          [isInvalid]="!!form.controls.dates.controls.range.errors"
          [errorText]="form.controls.dates.controls.range.errors | baseFieldValidation"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [readonly]="true"
        ></base-range-datepicker>
      </div>
    </div>
    <hr class="my-6" />
    <div class="row align-items-center mb-3">
      <div class="col-4">
        <label class="fw-medium">{{ 'work.shift.selection' | baseBusinessKey | translate }}</label>
      </div>
      <div class="col d-flex flex-column gap-2">
        <div class="d-flex">
          <span class="me-2">{{ 'work.shift.flexible' | baseBusinessKey | translate }}</span>
          <base-switch
            formControlName="flexShift"
            [reverseValue]="true"
            color="primary"
          ></base-switch>
          <span class="ms-1">{{ 'work.shift.fixed' | baseBusinessKey | translate }}</span>
        </div>
      </div>
    </div>

    <hr class="my-6" />

    <base-customer-weekdays-and-shifts
      [form]="form"
      [submitted]="submitted"
      [flexShift]="form.value.flexShift"
    ></base-customer-weekdays-and-shifts>

    <ng-container *ngIf="!form.controls.flexShift.value">
      <div
        class="row"
        formGroupName="shiftsAndPersons"
      >
        <div class="col-4">
          <label class="required fw-medium">{{ 'work.shift.persons' | baseBusinessKey | translate }}</label>
        </div>
        <div
          formGroupName="persons"
          class="col d-flex flex-column gap-2"
        >
          <ng-container *ngFor="let shift of timeShifts">
            <div class="row align-items-center">
              <i
                class="col-1 fa-regular"
                [ngClass]="shiftsIcons[shift.type]"
              ></i>
              <span class="col-7">{{
                ('externalEmployees.masterData.shiftReadiness.' + shift.type | baseBusinessKey | translate) +
                  ' (' +
                  shift.startTime +
                  ' - ' +
                  shift.endTime +
                  ')'
              }}</span>
              <input
                [formControlName]="shift.type + 'Persons'"
                type="number"
                class="surcharge-input-field surcharge-number-field col-4"
                min="0"
              />
            </div>
          </ng-container>
          <span
            class="font-red font-size-sm"
            *ngIf="form.controls.shiftsAndPersons.controls.persons.hasError('invalidShiftPersons') && submitted"
            >{{ 'validation.atLeastOnePerson' | baseBusinessKey | translate }}</span
          >
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="form.controls.flexShift.value">
      <div
        formGroupName="shiftsAndPersons"
        class="row align-items-center mb-3"
      >
        <div class="col-4">
          <label class="required fw-medium">{{ 'inquiry.amountPersons' | translate }}</label>
        </div>
        <base-input
          formControlName="amountPersons"
          type="number"
          class="col"
          [isInvalid]="!!form.controls.shiftsAndPersons.controls.amountPersons.errors"
          [errorMessage]="
            form.controls.shiftsAndPersons.controls.amountPersons.errors | baseFieldValidation: { min: 'amountMinOne' }
          "
        ></base-input>
      </div>
    </ng-container>
  </div>
</form>

<div class="d-flex align-items-center justify-content-between mt-6 mb-5">
  <base-button
    color="secondary"
    [size]="buttonSize.md"
    label="action.cancel"
    (click)="modalRef.dismiss()"
    [attr.data-cy]="'action.cancel'"
  ></base-button>
  <div class="d-flex">
    <base-button
      *ngIf="currentDataRange"
      color="secondary"
      [size]="buttonSize.md"
      label="action.remove"
      (click)="removeShiftPlanRange()"
      [attr.data-cy]="'action.remove'"
    ></base-button>
    <base-button
      class="btn-confirm ms-3"
      color="primary"
      [size]="buttonSize.md"
      label="shiftRegister"
      [attr.data-cy]="'modal.button.ok'"
      (click)="addShiftPlanRange()"
    ></base-button>
  </div>
</div>
